import { RestaurantCard } from "@/components/RestaurantCard";
import type { RestaurantWithEventSpaces } from "@/types/restaurant";

interface RestaurantListContentProps {
  restaurants: RestaurantWithEventSpaces[];
}

export const RestaurantListContent = ({ restaurants }: RestaurantListContentProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
      {restaurants.map((restaurant) => (
        <RestaurantCard key={restaurant.id} restaurant={restaurant} />
      ))}
    </div>
  );
};